var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyblog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5A5A5"
    },
    d: "M512,77.913v33.391H0V77.913c0-24.588,19.933-44.522,44.522-44.522h422.957 C492.066,33.391,512,53.325,512,77.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#777777"
    },
    d: "M397.913,66.226v1.113c0,4.61-3.738,8.348-8.348,8.348c-4.61,0-8.348-3.738-8.348-8.348v-1.113 c0-4.61,3.738-8.348,8.348-8.348C394.175,57.878,397.913,61.616,397.913,66.226z M422.957,57.878c-4.61,0-8.348,3.738-8.348,8.348 v1.113c0,4.61,3.738,8.348,8.348,8.348c4.61,0,8.348-3.738,8.348-8.348v-1.113C431.304,61.616,427.567,57.878,422.957,57.878z  M456.348,57.878c-4.61,0-8.348,3.738-8.348,8.348v1.113c0,4.61,3.738,8.348,8.348,8.348s8.348-3.738,8.348-8.348v-1.113 C464.696,61.616,460.958,57.878,456.348,57.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F2F4"
    },
    d: "M512,100.174v311.652c0,24.588-19.933,44.522-44.522,44.522H44.522 C19.933,456.348,0,436.414,0,411.826V100.174h66.783V22.261C66.783,9.966,76.749,0,89.043,0h89.043 c12.295,0,22.261,9.966,22.261,22.261v77.913H512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3E4ED"
    },
    d: "M200.348,22.261v77.913H66.783V22.261C66.783,9.966,76.749,0,89.043,0h89.043 C190.382,0,200.348,9.966,200.348,22.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2D1D8"
    },
    d: "M178.087,38.957v22.261c0,6.147-4.983,11.13-11.13,11.13h-66.783c-6.147,0-11.13-4.983-11.13-11.13 V38.957c0-6.147,4.983-11.13,11.13-11.13h66.783C173.104,27.826,178.087,32.809,178.087,38.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDFE2"
    },
    d: "M434.087,406.261H77.913c-12.295,0-22.261-9.966-22.261-22.261V261.565 c0-12.295,9.966-22.261,22.261-22.261h356.174c12.295,0,22.261,9.966,22.261,22.261V384 C456.348,396.295,446.382,406.261,434.087,406.261z M200.348,172.522L200.348,172.522c0-12.295-9.966-22.261-22.261-22.261H77.913 c-12.295,0-22.261,9.966-22.261,22.261l0,0c0,12.295,9.966,22.261,22.261,22.261h100.174 C190.382,194.783,200.348,184.816,200.348,172.522z M456.348,172.522L456.348,172.522c0-12.295-9.966-22.261-22.261-22.261H256 c-12.295,0-22.261,9.966-22.261,22.261l0,0c0,12.295,9.966,22.261,22.261,22.261h178.087 C446.382,194.783,456.348,184.816,456.348,172.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84A7B7"
    },
    d: "M386.625,282.228c0,26.78-21.709,48.489-48.489,48.489s-48.489-21.709-48.489-48.489 s21.71-48.489,48.489-48.489C364.915,233.739,386.625,255.448,386.625,282.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AB7C1"
    },
    d: "M421.259,447.609V512H255.014v-64.391c0-45.907,37.216-83.122,83.122-83.122l0,0 C384.043,364.486,421.259,401.702,421.259,447.609z M326.749,244.87c-14.485,0-26.228,11.743-26.228,26.228 c0,14.485,11.743,26.228,26.228,26.228c14.485,0,26.228-11.743,26.228-26.228C352.977,256.612,341.234,244.87,326.749,244.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84A7B7"
    },
    d: "M403.947,396.839c10.854,14.039,17.312,31.648,17.312,50.77V512H255.014v-44.962 c2.146,0.281,4.33,0.441,6.551,0.441h33.391c27.662,0,50.087-22.424,50.087-50.087l0,0 C345.043,386.108,384.813,372.089,403.947,396.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#256277"
    },
    d: "M464,503.652c0,4.61-3.738,8.348-8.348,8.348H226.187c-4.61,0-8.348-3.738-8.348-8.348 s3.738-8.348,8.348-8.348h229.465C460.262,495.304,464,499.042,464,503.652z M503.652,495.304h-1.64 c-4.61,0-8.348,3.738-8.348,8.348s3.738,8.348,8.348,8.348h1.64c4.61,0,8.348-3.738,8.348-8.348S508.262,495.304,503.652,495.304z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyblog);
export default __webpack_public_path__ + "static/media/emptyblog.aaedf2de5b6007754a87763a9107c288.svg";
export { ForwardRef as ReactComponent };